import { LIGHT_TOKENS, Print } from "./Print";
import { ByoAiStatic } from "../components/ByoAi";

/**
 * Lights-out mode. When the master interactivity flag is off, the site serves only this flat
 * Print/PDF résumé plus a bring-your-own-AI prompt — no nav, no Ask AI, no feedback, and zero
 * API / data / AI calls (main.tsx renders this before any network or auth init). Forced light to
 * match the print sheet regardless of the OS theme.
 */
export function StaticResume() {
  return (
    <div className="static-resume" style={LIGHT_TOKENS}>
      <div className="wrap-narrow section" style={{ paddingBottom: 0 }}>
        <ByoAiStatic />
      </div>
      <Print />
    </div>
  );
}
